"use client";
import { Button } from "@/app/components/ui/button";
import Link from "next/link";
import React from "react";

interface Props {
  auctionId?: number;
}

// const visibleButtonPaths = ['settings', 'lots'];
// const path = usePathname().split('/').slice(-1)[0];
// return visibleButtonPaths.includes(path) ?

// TODO: During when the auction is active, this
// should actually say 'Go to auction', rather than
// 'Preview Auction'.
//
// <ArrowTopRightIcon className="w-4 h-4 ml-2" />
const PreviewAuctionButton = ({ auctionId }: Props) => {
  if (!auctionId) return null;

  return (
    <Link href={`/auctions/${auctionId}`} target="_blank">
      <Button variant="outline" className="shadow-none">
        Preview
      </Button>
    </Link>
  );
};

export default PreviewAuctionButton;
